export default __webpack_public_path__ + "static/media/4.02d6bb43.png";